import { useUserId } from '@/auth/UserIdContext';
import { MarkdownDocEditor } from '@/components/MarkdownDocEditor/MarkdownDocEditor';

// The Brand "Additional Learnings" tab: a per-business, editable record of what Bridgeway
// knows BEYOND the profile — the owner's own answers, their market, their customers. The
// facts with their own tabs (business details, products, similar businesses) deliberately
// never appear here. Reuses the shared markdown editor (same one the email composer and
// grounding brief use). Business == user today (single-business), so the doc is keyed on
// userId — see CampaignSpace passing businessId={userId}.

export function AdditionalLearningsTab() {
	const userId = useUserId();

	return (
		<div className="flex min-h-0 flex-1 flex-col gap-3">
			<p className="text-sm text-(--text-muted)">
				Additional things Bridgeway has learned about your business — what
				you&apos;ve told us, and what we&apos;ve picked up about your market and
				your customers. Your business details, products, and similar businesses
				live in their own tabs. Add or correct anything; we keep your version.
			</p>
			<MarkdownDocEditor
				getPath={`/api/user/${userId}/additional-learnings/${userId}`}
				patchPath={`/api/user/${userId}/additional-learnings/${userId}`}
				testIdPrefix="additional-learnings"
				loadErrorCopy="We couldn't load what we've learned about your business. Please try again."
			/>
		</div>
	);
}
